var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.222229,
    y: 0.0722122,
    width: 16.8889,
    height: 16.0462,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1111 8.09532C17.1111 8.09532 13.9445 2.57944 8.66667 2.57944C3.3889 2.57944 0.222229 8.09532 0.222229 8.09532C0.222229 8.09532 3.3889 13.6112 8.66667 13.6112C13.9445 13.6112 17.1111 8.09532 17.1111 8.09532ZM1.4604 8.09532C1.97078 8.83232 2.55781 9.51874 3.21263 10.1442C4.57112 11.4369 6.4289 12.6083 8.66668 12.6083C10.9045 12.6083 12.7612 11.4369 14.1218 10.1442C14.7766 9.51873 15.3636 8.83232 15.874 8.09533C15.3636 7.35833 14.7766 6.67191 14.1218 6.04642C12.7612 4.7537 10.9034 3.58233 8.66668 3.58233C6.4289 3.58233 4.57218 4.7537 3.21157 6.04642C2.55674 6.67191 1.96972 7.35833 1.45934 8.09533L1.4604 8.09532Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 5.5881C7.20926 5.5881 6.02779 6.71062 6.02778 8.09532C6.02778 9.48001 7.20925 10.6025 8.66666 10.6025C10.1241 10.6025 11.3055 9.48003 11.3056 8.09534C11.3056 6.71064 10.1241 5.58811 8.66669 5.5881H8.66667ZM4.97223 8.09532C4.97223 6.84128 5.67639 5.6825 6.81945 5.05548C7.96252 4.42846 9.37083 4.42846 10.5139 5.05548C11.657 5.6825 12.3611 6.84128 12.3611 8.09532C12.3611 9.34936 11.657 10.5081 10.5139 11.1352C9.37083 11.7622 7.96252 11.7622 6.81945 11.1352C5.67639 10.5081 4.97223 9.34936 4.97223 8.09532V8.09532Z",
    fill: "#BEBEBE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.59687e8e54fe4a2789d84ae7842830e3.svg";
export { ForwardRef as ReactComponent };